export const systemTranslations = {
    "de-DE": {
        "animalsTitle": "Tiere",
        "april": "April",
        "arrivalAddress": "Drockerhof<br/>St. Jakob 18<br/>39040 Villnöß (BZ)<br/>Italien",
        "arrivalFindUsOnGoogleMaps": "Finden Sie uns auch gerne auf Google Maps",
        "arrivalFullAddress": "Adresse",
        "arrivalMapsDisabled": "Diese Google Maps-Ansicht ist deaktiviert, da nur notwendige Cookies aktiviert wurden.",
        "arrivalSubtitle": "So erreichen Sie unseren Drockerhof",
        "arrivalTitle": "Anreise",
        "august": "August",
        "bookRoomAdults": "Erwachsene",
        "bookRoomArrival": "Ankunft",
        "bookRoomBody": "Vielen Dank für Ihr Interesse an einem Urlaub bei uns! Wir senden Ihnen so schnell wie möglich ein Angebot zu, sobald wir Ihre Anfrage erhalten.",
        "bookRoomChildren": "Kinder",
        "bookRoomContactUs": "Schreiben Sie uns",
        "bookRoomDeparture": "Abreise",
        "bookRoomEmail": "E-Mail",
        "bookRoomErrorMissingChildrenMessage": "Bitte geben Sie uns in der Nachricht an, wie alt Ihre Kinder sind, damit wir ein passendes Angebot für Sie erstellen können.",
        "bookRoomErrorMissingDates": "Bitte geben Sie den Zeitraum an, in dem Sie bei uns Urlaub machen möchten.",
        "bookRoomErrorMissingEmail": "Bitte geben Sie eine E-Mail Adresse an, mit der wir Sie kontaktieren können.",
        "bookRoomErrorMissingName": "Bitte geben Sie Ihren Vor- und Nachnamen an.",
        "bookRoomErrorMissingPeople": "Bitte geben Sie die Anzahl der Gäste ein.",
        "bookRoomErrorSendingMail": "Mail konnte nicht versandt werden.",
        "bookRoomGuests": "Gäste",
        "bookRoomMessage": "Nachricht",
        "bookRoomMessageInfo": "Gerne können Sie uns weitere Informationen zukommen lassen, beispielsweise ob Sie bestimmte Präferenzen für die Wohnung haben oder das Alter Ihrer Kinder angeben möchten.",
        "bookRoomName": "Vorname",
        "bookRoomNumberOf": "Anzahl",
        "bookRoomPets": "Haustiere",
        "bookRoomPhone": "Telefon",
        "bookRoomPrivacy1": "und die Informationen zum Widerruf.",
        "bookRoomPrivacy2": "Mit dem Absenden der Anfrage stimmen Sie unseren Datenschutzbestimmungen zu.",
        "bookRoomPrivacyLink": "Unsere Datenschutzbestimmungen",
        "bookRoomSendRequest": "Anfrage senden",
        "bookRoomSuccessSendingMail": "Ihre Anfrage wurde erfolgreich versendet. Wir werden uns so bald wie möglich bei Ihnen melden!",
        "bookRoomSurname": "Nachname",
        "bookRoomTitle": "Unverbindliche Urlaubsanfrage",
        "contactAddress": "Messner Günther<br/>St. Jakob 18<br/>39040 Villnöß (BZ)<br/>Italien",
        "contactTelephone": "Telefon",
        "contactTitle": "Kontakt",
        "cookieBannerAcceptAll": "Alle akzeptieren",
        "cookieBannerAcceptOnlyNecessary": "Nur notwendige akzeptieren",
        "cookieBannerExplanation": "Wir verwenden Cookies, um Ihr Erlebnis zu verbessern. Bitte akzeptieren Sie, um fortzufahren. Sie können mehr über die Nutzung der Cookies lesen unter",
        "cookieEnableAll": "Alle Cookies aktivieren",
        "cookiePlaceholderExplanation": "Sie können mehr über die Nutzung der Cookies lesen unter",
        "ctaButton": "Kostenloses Angebot anfordern",
        "ctaDescription": "Erleben Sie die perfekte Mischung aus Komfort und Abenteuer auf dem Drockerhof. Wir helfen Ihnen gerne, Ihren Traumurlaub im Herzen der Dolomiten zu planen.",
        "ctaSecondaryButton": "Unsere Ferienwohnungen entdecken",
        "ctaTitle": "Bereit für die Dolomiten?",
        "december": "Dezember",
        "environmentTitle": "Umgebung",
        "february": "Februar",
        "footerAddress1": "Urlaub auf dem Bauernhof Südtirol",
        "footerAddress2": "St. Jakob 18 - 39040 - Villnöß",
        "footerAddress3": "Südtirol - Dolomiten - Italien",
        "footerArrival": "Anreise",
        "footerCallUs": "Anrufen",
        "footerFarmmagazine": "Hofmappe",
        "footerFiscalCode": "MwSt. Nr.",
        "footerLegalNotes": "Impressum",
        "footerLogo": "drockerhof-logo-de",
        "footerPrices": "Preise & Informationen",
        "footerPrivacy": "Datenschutz",
        "footerSitemap": "Sitemap",
        "homeTitle": "Drockerhof - Ihr Traumurlaub auf dem Bauernhof in Südtirol",
        "homeTitle2": "",
        "january": "Jänner",
        "july": "Juli",
        "june": "Juni",
        "legalInformationSubtitle": "Auftraggeber und Verantwortlicher für die Inhalte",
        "legalInformationTitle": "Impressum",
        "march": "März",
        "may": "Mai",
        "navApartments": "Wohnungen",
        "navApartmentsApartments": "Wohnungen",
        "navApartmentsPrices": "Preise",
        "navApartmentsServices": "Dienste",
        "navArrival": "Anreise",
        "navBookRoom": "Anfrage",
        "navContact": "Kontakt",
        "navHome": "Startseite",
        "navHomepage": "Drockerhof",
        "navHomepageAnimals": "Tiere",
        "navHomepageEnvironment": "Umgebung",
        "navHomepageHistory": "Der Hof",
        "navHomepageTheFamily": "Die Familie",
        "navLogo": "drockerhof-logo-de",
        "navSheep": "Brillenschaf",
        "navTitle": "Drockerhof",
        "november": "November",
        "october": "Oktober",
        "privacyTitle": "Datenschutz",
        "september": "September",
        "sheepTitle": "Villnößer Brillenschaf",
        "sitemapAboutCategory": "Über uns",
        "sitemapAccommodationCategory": "Unterkunft",
        "sitemapDescription": "Hier finden Sie eine Übersicht aller Seiten auf unserer Website.",
        "sitemapLastUpdated": "Zuletzt aktualisiert",
        "sitemapLegalCategory": "Rechtliche Informationen",
        "sitemapMainCategory": "Hauptseiten",
        "sitemapNatureCategory": "Natur & Umwelt",
        "sitemapVisitCategory": "Besuch bei uns",
        "whatsappMessage": "Anfrage%20Drockerhof"
    },
    "it-IT": {
        "animalsTitle": "Animali",
        "april": "Aprile",
        "arrivalAddress": "Drockerhof<br/>San Giacomo 18<br/>39040 Funes (BZ)<br/>Italia",
        "arrivalFindUsOnGoogleMaps": "Trovateci anche su Google Maps",
        "arrivalFullAddress": "Indirizzo",
        "arrivalMapsDisabled": "Questa visualizzazione di Google Maps è disabilitata perché sono stati abilitati solo i cookie necessari.",
        "arrivalSubtitle": "Così raggiunge il nostro Drockerhof",
        "arrivalTitle": "Arrivo",
        "august": "Agosto",
        "bookRoomAdults": "Adulti",
        "bookRoomArrival": "Arrivo",
        "bookRoomBody": "Grazie per il suo interesse in una vacanza con noi! Una volta ricevuta la sua richiesta, le invieremo un'offerta il prima possibile.",
        "bookRoomChildren": "Bambini",
        "bookRoomContactUs": "Scrivici",
        "bookRoomDeparture": "Partenza",
        "bookRoomEmail": "Email",
        "bookRoomErrorMissingChildrenMessage": "Prego indicare l'età dei suoi figli nel messaggio, così le possiamo fare un'offerta adeguata.",
        "bookRoomErrorMissingDates": "Prego indicare un periodo nel quale vorrebbe fare ferie da noi.",
        "bookRoomErrorMissingEmail": "Prego indicare un indirizzo email, così la possiamo contattare.",
        "bookRoomErrorMissingName": "La preghiamo di indicare nome e cognore.",
        "bookRoomErrorMissingPeople": "Prego indicare il numero di ospiti.",
        "bookRoomErrorSendingMail": "La mail non è stata inviata.",
        "bookRoomGuests": "Ospiti",
        "bookRoomMessage": "Messaggio",
        "bookRoomMessageInfo": "Siete invitati a fornirci ulteriori informazioni, come eventuali preferenze specifiche per l'appartamento o l'età dei vostri figli.",
        "bookRoomName": "Nome",
        "bookRoomNumberOf": "Numero",
        "bookRoomPets": "Animali",
        "bookRoomPhone": "Telefono",
        "bookRoomPrivacy1": "e le informazioni sulla cancellazione.",
        "bookRoomPrivacy2": "Inviando la richiesta, si accetta la nostra politica sulla privacy.",
        "bookRoomPrivacyLink": "La nostra politica sulla privacy",
        "bookRoomSendRequest": "Invia richiesta",
        "bookRoomSuccessSendingMail": "La sua richiesta è stata inviata con successo. Ci metteremo in contatto con lei il prima possibile!",
        "bookRoomSurname": "Cognome",
        "bookRoomTitle": "Richiesta di vacanza",
        "contactAddress": "Messner Günther<br/>San Giacomo 18<br/>39040 Funes (BZ)<br/>Italia",
        "contactTelephone": "Telefono",
        "contactTitle": "Contatto",
        "cookieBannerAcceptAll": "Accetta tutti",
        "cookieBannerAcceptOnlyNecessary": "Accetta solo necessari",
        "cookieBannerExplanation": "Utilizziamo i cookie per migliorare la vostra esperienza. Accettare per continuare. Per ulteriori informazioni sul nostro utilizzo, consultare il sito",
        "cookieEnableAll": "Abilita tutti i cookie",
        "cookiePlaceholderExplanation": "Per ulteriori informazioni sul nostro utilizzo, consultare il sito",
        "ctaButton": "Richiedi un Preventivo Gratuito",
        "ctaDescription": "Scopri il perfetto connubio tra comfort e avventura al Drockerhof. Lasciaci aiutarti a pianificare la tua vacanza da sogno nel cuore delle Dolomiti.",
        "ctaSecondaryButton": "Scopri i Nostri Appartamenti",
        "ctaTitle": "Pronto a Vivere le Dolomiti?",
        "december": "Dicembre",
        "environmentTitle": "Dintorni",
        "february": "Febbraio",
        "footerAddress1": "Vacanze in agriturismo in Alto Adige",
        "footerAddress2": "San Giacomo 18 - 39040 - Funes",
        "footerAddress3": "Alto Adige - Dolomiti - Italia",
        "footerArrival": "Arrivo",
        "footerCallUs": "Chiamaci",
        "footerFarmmagazine": "Mappa del maso",
        "footerFiscalCode": "Codice Fiscale",
        "footerLegalNotes": "Note legali",
        "footerLogo": "drockerhof-logo-it",
        "footerPrices": "Prezzi e informazioni",
        "footerPrivacy": "Protezione dei dati",
        "footerSitemap": "Sitemap",
        "homeTitle": "Drockerhof - La Vostra Vacanza da Sogno in Agriturismo in Alto Adige",
        "homeTitle2": "",
        "january": "Gennaio",
        "july": "Luglio",
        "june": "Giugno",
        "legalInformationSubtitle": "",
        "legalInformationTitle": "Note legali",
        "march": "Marzo",
        "may": "Maggio",
        "navApartments": "Appartamenti",
        "navApartmentsApartments": "Appartamenti",
        "navApartmentsPrices": "Prezzi",
        "navApartmentsServices": "Servizi",
        "navArrival": "Arrivo",
        "navBookRoom": "Richiesta",
        "navContact": "Contatto",
        "navHome": "Pagina iniziale",
        "navHomepage": "Drockerhof",
        "navHomepageAnimals": "Animali",
        "navHomepageEnvironment": "Dintorni",
        "navHomepageHistory": "Il maso",
        "navHomepageTheFamily": "La famiglia",
        "navLogo": "drockerhof-logo-it",
        "navSheep": "Pecore",
        "navTitle": "Drockerhof",
        "november": "Novembre",
        "october": "Ottobre",
        "privacyTitle": "Privacy",
        "september": "Settembre",
        "sheepTitle": "Pecora Occhialuta della Val di Funes",
        "sitemapAboutCategory": "Chi siamo",
        "sitemapAccommodationCategory": "Alloggio",
        "sitemapDescription": "Qui puoi trovare una panoramica di tutte le pagine del nostro sito web.",
        "sitemapLastUpdated": "Ultimo aggiornamento",
        "sitemapLegalCategory": "Informazioni legali",
        "sitemapMainCategory": "Pagine principali",
        "sitemapNatureCategory": "Natura & Ambiente",
        "sitemapVisitCategory": "Visitaci",
        "whatsappMessage": "Richiesta%20Drockerhof"

    },
    "en-US": {
        "animalsTitle": "Animals",
        "april": "April",
        "arrivalAddress": "Drockerhof<br/>San Giacomo 18<br/>39040 Funes (BZ)<br/>Italy",
        "arrivalFindUsOnGoogleMaps": "Find us on Google Maps",
        "arrivalFullAddress": "Address",
        "arrivalMapsDisabled": "This Google Maps view is disabled because only necessary cookies were enabled.",
        "arrivalTitle": "Arrival",
        "august": "August",
        "bookRoomAdults": "Adults",
        "bookRoomArrival": "Arrival",
        "bookRoomBody": "Thank you for your interest in a vacation with us! We will send you an offer as soon as possible once we receive your request.",
        "bookRoomChildren": "Children",
        "bookRoomContactUs": "Contact us",
        "bookRoomDeparture": "Departure",
        "bookRoomEmail": "E-Mail",
        "bookRoomErrorMissingChildrenMessage": "Please provide the age of your children in the message. This helps us create an adequate offer for you.",
        "bookRoomErrorMissingDates": "Please provide the date period in which you would like to stay with us.",
        "bookRoomErrorMissingEmail": "Please provide an e-mail address, so that we can contact you.",
        "bookRoomErrorMissingName": "Please provide name and surname.",
        "bookRoomErrorMissingPeople": "Please provide the number of guests.",
        "bookRoomErrorSendingMail": "The email was not sent.",
        "bookRoomGuests": "Guests",
        "bookRoomMessage": "Message",
        "bookRoomMessageInfo": "You are welcome to provide us with additional information, such as any specific preferences for the apartment or the ages of your children.",
        "bookRoomName": "Name",
        "bookRoomNumberOf": "Number of",
        "bookRoomPets": "Pets",
        "bookRoomPhone": "Phone",
        "bookRoomPrivacy1": "and information on revocation.",
        "bookRoomPrivacy2": "By submitting the request, you agree to our privacy policy.",
        "bookRoomPrivacyLink": "Our privacy policy",
        "bookRoomSendRequest": "Send request",
        "bookRoomSuccessSendingMail": "Your request has been successfully sent. We will get back to you as soon as possible!",
        "bookRoomSurname": "Surname",
        "bookRoomTitle": "Vacation Request",
        "contactAddress": "Messner Günther<br/>San Giacomo 18<br/>39040 Funes (BZ)<br/>Italy",
        "contactTelephone": "Telephone",
        "contactTitle": "Contact",
        "cookieBannerAcceptAll": "Accept all",
        "cookieBannerAcceptOnlyNecessary": "Accept necessary only",
        "cookieBannerExplanation": "We use cookies to enhance your experience. Please accept to continue. You can read more on our usage at",
        "cookieEnableAll": "Enable all cookies",
        "cookiePlaceholderExplanation": "You can read more on our usage at",
        "ctaButton": "Request a Free Quote",
        "ctaDescription": "Discover the perfect blend of comfort and adventure at Drockerhof. Let us help you plan your dream vacation in the heart of the Dolomites.",
        "ctaSecondaryButton": "Explore Our Apartments",
        "ctaTitle": "Ready to Experience the Dolomites?",
        "december": "December",
        "environmentTitle": "Environment",
        "february": "February",
        "footerAddress1": "Vacation on the farm South Tyrol",
        "footerAddress2": "San Giacomo 18 - 39040 - Funes",
        "footerAddress3": "South Tyrol - Dolomites - Italy",
        "footerArrival": "Arrival",
        "footerCallUs": "Call Us",
        "footerFarmmagazine": "Farm magazine",
        "footerFiscalCode": "Fiscal Code",
        "footerLegalNotes": "Legal Notes",
        "footerLogo": "drockerhof-logo-en",
        "footerPrices": "Prices & Information",
        "footerPrivacy": "Privacy",
        "footerSitemap": "Sitemap",
        "homeTitle": "Drockerhof - Your Dream Farm Vacation in South Tyrol",
        "homeTitle2": "",
        "january": "January",
        "july": "July",
        "june": "June",
        "legalInformationSubtitle": "",
        "legalInformationTitle": "Legal notes",
        "march": "March",
        "may": "May",
        "navApartments": "Apartments",
        "navApartmentsApartments": "Apartments",
        "navApartmentsPrices": "Prices",
        "navApartmentsServices": "Services",
        "navArrival": "Arrival",
        "navBookRoom": "Request",
        "navContact": "Contact",
        "navHome": "Homepage",
        "navHomepage": "Drockerhof",
        "navHomepageAnimals": "Animals",
        "navHomepageEnvironment": "Environment",
        "navHomepageHistory": "The Farm",
        "navHomepageTheFamily": "The Family",
        "navLogo": "drockerhof-logo-en",
        "navSheep": "Sheep",
        "navTitle": "Drockerhof",
        "november": "November",
        "october": "October",
        "privacyTitle": "Privacy",
        "september": "September",
        "sheepTitle": "Villnöss Spectacled Sheep",
        "sitemapAboutCategory": "About Us",
        "sitemapAccommodationCategory": "Accommodation",
        "sitemapDescription": "Here you can find an overview of all pages on our website.",
        "sitemapLastUpdated": "Last updated",
        "sitemapLegalCategory": "Legal Information",
        "sitemapMainCategory": "Main Pages",
        "sitemapNatureCategory": "Nature & Environment",
        "sitemapVisitCategory": "Visiting Us",
        "surchargesTitle": "Price terms",
        "whatsappMessage": "Request%20Drockerhof"
    }
}
